// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jVTJ","question":"styles_question__2ktQO","inputVisibleButton":"styles_inputVisibleButton__3q_BU","note":"styles_note__3mPto"};